const heading = document.querySelector('.block-text-columns .wp-block-heading');
if (heading) {
	heading.setAttribute('data-aos', 'fade');
	heading.setAttribute('data-aos-duration', '800');
}

// Add AOS to each block-column with staggered delay
const columns = document.querySelectorAll('.block-columns .block-column');
columns.forEach((column, index) => {
	column.setAttribute('data-aos', 'fade-up');
	column.setAttribute('data-aos-duration', '800');
	column.setAttribute('data-aos-delay', `${index * 100}`);
});
